import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SiteApi } from '../api/site.api';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

@Injectable()
export class SiteHttpApi extends SiteApi {
  private readonly http = inject(HttpClient);

  /** Тела у успеха нет, значим сам факт 200; `org_not_found` от сетевого сбоя отличает стор по коду. */
  override checkDomain(): Observable<void> {
    return this.http
      .get<ApiEnvelope<void> | null>(apiPath('/api/users/client'))
      .pipe(unwrapEnvelope<void>(), mapApiError());
  }
}
